// extracted by mini-css-extract-plugin
export default {"title-user":"MySocialMemoryPrint_title-user__b8Yba"};